import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ProduitService } from '@core/services/produit.service';
import { Campagne } from '@core/models/campagne.model';
import { GlobalDataService } from '@core/services/global-data.service';
import { ActivatedRoute, NavigationBehaviorOptions, Router } from '@angular/router';
import { CampagneTypologieService } from '@core/services';
import { navPaths } from '@core/models/support.model';


@Component({
  selector: 'app-campagne-typologie-finition',
  templateUrl: './campagne-typologie-finition.component.html',
  styleUrls: ['./campagne-typologie-finition.component.scss']
})
export class CampagneTypologieFinitionComponent implements OnInit {

  typologie: string = "autre";
  navigationOption: NavigationBehaviorOptions = {};

  constructor(
    private router: Router,
    private readonly activatedRoute: ActivatedRoute,    
    public _GlobalDataService: GlobalDataService,
    public _CampagneTypologieService: CampagneTypologieService,
  ) {

    const routeState = this.router.getCurrentNavigation()?.extras?.state || history.state;
    const typologieFromState = routeState?.['typologie'];
    if (typologieFromState === 'autre' || typologieFromState === 'lettre' || typologieFromState === 'enveloppe') {
      this.typologie = typologieFromState;
    }
   }

  ngOnInit(): void {
  }

  gotoTypologieSelection(): void {
    console.log('gotoTypologieSelection');
    this._CampagneTypologieService.navigate(navPaths.selection, this.activatedRoute.parent as ActivatedRoute, this.navigationOption);
  }  

}
